module.exports = __webpack_public_path__ + "media/startsida.97818112.webm";